import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import {ScratchFileContent} from 'pipelines/files/ScratchFileTypes';

export default function getDownloadFileAction(file: ScratchFileContent): OverflowDataViewAction {
  return {
    icon: 'download',
    label: 'Download',
    onClick: async () => {
      const signedURL = await performSignedFileQuery(file.externalFileId!, file.downloadUrl!, file.id);
      if (signedURL == null) {
        return;
      }
      window.open(signedURL, '_blank', 'noopener noreferrer');
    },
  };
}
